import React from 'react'
import { Skeleton, Space } from 'antd';
import './skeletonLoader.css';

const Loader = () => {
  return (
    <>
      <div className='header-skeleton'>
        <Space>
          <Skeleton.Image active style={{ height: '35px', width: '35px', marginTop: '12px' }} />
          <Skeleton.Button active style={{ height: '28px', width: '40px', margin: '12px' }} />
          <Skeleton.Button active style={{ height: '28px', width: '40px', margin: '12px' }} />
          <Skeleton.Button active style={{ height: '28px', width: '40px', margin: '12px' }} />
          <Skeleton.Button active style={{ height: '28px', width: '40px', margin: '12px' }} />
        </Space>
      </div>
      <div className="content-container">
        <div className='sidebar-skeleton'>
          <Space style={{ display: 'flex', flexDirection: 'column' }}>
            <Skeleton.Button active style={{ height: '28px', width: '40px', margin: '8px' }} />
            <Skeleton.Button active style={{ height: '28px', width: '40px', margin: '8px' }} />
            <Skeleton.Button active style={{ height: '28px', width: '40px', margin: '8px' }} />
            <Skeleton.Button active style={{ height: '28px', width: '40px', margin: '8px' }} />
            <Skeleton.Button active style={{ height: '28px', width: '40px', margin: '8px' }} />
            <Skeleton.Button active style={{ height: '28px', width: '40px', margin: '8px' }} />
            <Skeleton.Button active style={{ height: '28px', width: '40px', margin: '8px' }} />
            <Skeleton.Button active style={{ height: '28px', width: '40px', margin: '8px' }} />
            <Skeleton.Button active style={{ height: '28px', width: '40px', margin: '8px' }} />
          </Space>
        </div>
        <div className="spaces-skeleton ">
          <Skeleton.Button active style={{ height: '450px', width: '750px' }} />
        </div>
      </div>

    </>

  )
}

export default Loader
